export default __webpack_public_path__ + "static/media/barChart.8000c9bf.png";